module.exports = __webpack_public_path__ + "img/visit.efcc3eff.svg";